import NavigationLink from 'components/links/NavigationLink';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CallToActionNavigationLink: FunctionComponent<Props> = ({
    className = '',
    link,
    onClick,
    testId = TEST_ID,
    text
}) => (
    <NavigationLink
        className={`${className} ${styles.ctaNavigationLink}`}
        isExactMatch={true}
        onClick={onClick}
        testId={testId}
        text={text}
        to={link}
    />
);

export default CallToActionNavigationLink;
